const state = {
  // 알림 상태
  alert: {
    show: false,
    message: '',
    status: 'info' // 'info', 'success', 'warning', 'error'
  }
};

const getters = {
  // 알림 상태 getters
  alertData: state => state.alert
};

const mutations = {
  // 알림 관련 mutations
  setAlert(state, { show, message, status }) {
    state.alert = { show, message, status };
  }
};

const actions = {
  // 알림 표시 action
  showAlert({ commit, dispatch }, { message, status = 'info' }) {
    commit('setAlert', { show: true, message, status });

    // 3초 후 자동으로 알림 숨기기
    setTimeout(() => {
      dispatch('hideAlert');
    }, 3000);
  },

  // 알림 숨기기 action
  hideAlert({ commit }) {
    commit('setAlert', { show: false, message: '', status: 'info' });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
